import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialDataThunk } from 'slices/initialData/thunk';

function extractPairsFromConfig(config) {
    const sections = Array.isArray(config?.sections) ? config.sections : [];
    const pairs = [];
    for (let i = 0; i < sections.length; i++) {
        const section = sections[i] || {};
        const initial = section.initial || {};
        const dashboard_id = initial.dashboard_id;
        const chartid = initial.chartid;
        if (dashboard_id != null && chartid != null) {
            pairs.push({ dashboard_id, chartid });
        }
    }
    return pairs;
}

export default function usePrefetchInitialData(config) {
    const dispatch = useDispatch();
    const slice = useSelector(state => state?.InitialDataReducer);

    const uniquePairs = useMemo(() => {
        const pairs = extractPairsFromConfig(config);
        const seen = new Set();
        const out = [];
        for (let i = 0; i < pairs.length; i++) {
            const p = pairs[i];
            const key = `${p.dashboard_id}:${p.chartid}`;
            if (seen.has(key)) continue;
            seen.add(key);
            out.push({ key, ...p });
        }
        return out;
    }, [config]);

    useEffect(() => {
        if (!Array.isArray(uniquePairs) || uniquePairs.length === 0) return;
        const byKey = slice?.byKey || {};
        const loadingByKey = slice?.loadingByKey || {};
        for (let i = 0; i < uniquePairs.length; i++) {
            const { key, dashboard_id, chartid } = uniquePairs[i];
            if (byKey[key] || loadingByKey[key]) continue;
            dispatch(fetchInitialDataThunk({ dashboard_id, chartid }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uniquePairs, slice?.byKey, slice?.loadingByKey, dispatch]);

    return uniquePairs.map(p => p.key);
}


